import clsx from 'clsx';
import React, { FC } from 'react';

interface TextContentProps {
  content?: string | null;
}
const TextContent: FC<TextContentProps> = ({ content }) => {
  return (
    <p
      className={clsx('text-base font-bold', {
        'text-content-base-default': content,
        'text-content-base-subdued': !content,
      })}
    >
      {content ?? 'N/A'}
    </p>
  );
};

export default TextContent;
